<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      screenWidth: document.body.clientWidth
    };
  },
  created() {
    // if(process.env.NODE_ENV === 'production' && location.protocol !== "https:") location.protocol = "https:";

    this.$store.dispatch("getZh");
    this.$store.dispatch("getEn");
    window.addEventListener("resize", () => {
      this.screenWidth = document.body.clientWidth;
    });
  }
};
</script>

<style>
@import "./assets/css/base.css";
</style>



// WEBPACK FOOTER //
// src/App.vue